import { useEffect, useMemo } from 'react';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import actions from '@src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, useMediaQuery } from '@mui/material';
import { ONBOARDING_POPUP_TYPE } from '@src/constants';
import useFeatureFlags from './useFeatureFlags';
import {
  useCheckCloningRoute,
  useCheckDubbingRoute,
  useCheckHomeProjectRoute,
} from './useCheckDubbingRoute';

const useOnboardingPopup = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const { getFeatureValue } = useFeatureFlags();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const userId = user?.id;

  const onboardingPopupEnabled = getFeatureValue(
    FEATURE_KEYS.ONBOARDING_POPUP,
    {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  const isDubbingRoute = useCheckDubbingRoute();
  const isProjectRoute = useCheckHomeProjectRoute();
  const isVoiceCloningRoute = useCheckCloningRoute();

  const popupConfigs = useMemo(
    () => [
      {
        key: ONBOARDING_POPUP_TYPE.DUBBING,
        route: isDubbingRoute,
      },
      {
        key: ONBOARDING_POPUP_TYPE.PROJECT,
        route: isProjectRoute,
      },
      {
        key: ONBOARDING_POPUP_TYPE.VOICE_CLONING,
        route: isVoiceCloningRoute,
      },
    ],
    [isDubbingRoute, isProjectRoute, isVoiceCloningRoute],
  );

  useEffect(() => {
    if (!userId || !onboardingPopupEnabled || isMobile) return;

    popupConfigs.forEach(({ key, route }) => {
      if (!route) return;

      const storageKey = `ONBOARDING_POPUP_${key}_${userId}`;
      const didShow = localStorage.getItem(storageKey);

      if (!didShow) {
        dispatch(actions.onboardingPopup.showOnboardingPopup({ type: key }));
        localStorage.setItem(storageKey, 'true');
      }
    });
  }, [popupConfigs, userId, onboardingPopupEnabled, isMobile, dispatch]);
};

export default useOnboardingPopup;
